import { IProject } from "src/modules/pe-fest-module/data/interfaces"
import SchoolPartners from "./SchoolPartners"
import { getFeedRoute, getRoute } from "src/libs/layouts"
import { Link, useNavigate } from "react-router-dom"
import { syncAction } from "src/modules/pe-landing-module/data/actions"
import { SET_FILTERS_ACTIONS } from "src/modules/pe-fest-module/data/actionTypes"

/* Protopia Ecosystem component */
export interface ISchoolLabelProps {
    project: IProject 
}
const SchoolLabel = (props: ISchoolLabelProps): JSX.Element => {
    return <div className='pe-school-label-container'> 
        { 
            props.project.fmru_school.map(item => <SchoolItem school={ item } project={ props.project } key={ item.id } />)
        } 
    </div>
}
export default SchoolLabel

const SchoolItem = ({ project, school }: any):JSX.Element => {
    const navigate = useNavigate()
    const routeSingle = getFeedRoute("PEFestProject") 
    const _url = routeSingle
        ? 
        `/${ getRoute(routeSingle)}?schools=-1,${ school.id }` 
        : 
        "/"
    const onClick = () => {
        const selectTracks = [ "-1", school.id ] 
        syncAction(
            SET_FILTERS_ACTIONS, 
            { 
                filters:{ 
                    schools: selectTracks
                } 
            } 
        )
        navigate( _url )
    }
    return <div> 
        <div className="d-flex align-items-center flex-wrap" data-testid="project-data-school"> 
            <div data-to={ _url } className="text-nowrap mr-3 pointer hover" onClick={onClick}>{ school.title }</div> 
            <SchoolPartners project={ project } school={ school } />
        </div> 
    </div>
}